import type { EditableCallback } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../../graphql';
import { createRelationshipStatusColDef } from '../../../../../components/shared-columns/relationship-status';
import type { FirmSalesCoverageGridContext } from '../FirmsSalesCoverageGrid.model';
import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';

export const editable: EditableCallback<
  FirmSalesCoverageGridItemFragment,
  RolodexRecordStatus,
  FirmSalesCoverageGridContext
> = ({ context, data }) => {
  return (
    context.isRelationshipStatusEditable && data?.employeeStatus !== RolodexRecordStatus.Deleted
  );
};

export const relationshipStatusColDef =
  createRelationshipStatusColDef<FirmSalesCoverageGridItemFragment>({
    editable,
  });
